/* pb-stage · PurjFam POD + XKAH Pro bundle page, "The Stage" (founder pick B, 3 Nov 2026).
   Loaded only on templates/product.pod-xkah.json (pdpv9 xk_picker = 'pod'). It never posts anything and never builds a price:
   a pick finds the matching variant in pdpv9's own server-rendered variant blob and sets pdpv9's hidden <select data-optselect> to it, so
   price, URL, stock state, Add to cart, Buy it now, the sticky bars and the screen-reader status are all the house pipeline.
   Honest picks: a colour is struck only when NO pair of it can be bought (read live from the blob). Tapping a struck colour changes nothing and
   says so, with a button to the nearest one. Picking a colour whose pair with the other choice is sold out shows that pair as Sold out; it never
   moves the other colour on its own. Availability is never typed here. No animation: the photo swaps once decoded. */
(function () {
  'use strict';
  if (window.__pbStage) return;
  window.__pbStage = 1;

  function money(c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init(root) {
    if (root.__pb) return;
    root.__pb = 1;
    var vs = [];
    try { vs = JSON.parse($('[data-pdpv9-variants]', root).textContent) || []; } catch (e) { return; }
    if (!vs.length) return;
    var sel = $('[data-optselect]', root);
    var vin = $('[data-variant-input]', root);
    var wasOk = window.__v7WasOk || {};

    var keep = [];
    try { new URLSearchParams(location.search).forEach(function (v, k) { if (k !== 'variant') keep.push([k, v]); }); } catch (e1) {}

    /* the order colours are listed in, as the chips are rendered (server-side, from the option values) */
    var podOrder = $$('[data-pb-si][data-k="pod"]', root).map(function (e) { return e.dataset.n; });
    var proOrder = $$('[data-pb-si][data-k="pro"]', root).map(function (e) { return e.dataset.n; });
    var NOIR = ['Black', 'Silver', 'Lotus Green', 'Night Blue', 'Deep Purple'];
    function lineOf(p) { return NOIR.indexOf(p) > -1 ? 'noir' : 'vivid'; }

    function byId(id) { for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === String(id)) return vs[i]; } return null; }
    function match(p, x) { for (var i = 0; i < vs.length; i++) { if (vs[i].options[0] === p && vs[i].options[1] === x) return vs[i]; } return null; }
    function ok(p, x) { var v = match(p, x); return !!(v && v.available); }
    function podOk(p) { return vs.some(function (v) { return v.options[0] === p && v.available; }); }
    function proOk(x) { return vs.some(function (v) { return v.options[1] === x && v.available; }); }

    var start = byId(vin && vin.value) || vs[0];
    var S = { pod: start.options[0], pro: start.options[1], msg: null };
    var note = $('[data-pb-msg].is-on');
    if (note) { S.msg = { k: note.dataset.pbMsg, t: (note.textContent || '').trim(), to: null }; }

    /* nearest colour on one axis that can still be bought: same line first (POD), looking forward from the one asked about, wrapping */
    function near(k, n) {
      var order = k === 'pod' ? podOrder : proOrder, i = order.indexOf(n), tries = [], j, c;
      for (j = 1; j < order.length; j++) { c = order[(i + j) % order.length]; tries.push(c); }
      if (k === 'pod') {
        var same = tries.filter(function (c2) { return lineOf(c2) === lineOf(n); }), other = tries.filter(function (c2) { return lineOf(c2) !== lineOf(n); });
        tries = same.concat(other);
      }
      for (j = 0; j < tries.length; j++) { if (k === 'pod' ? podOk(tries[j]) : proOk(tries[j])) return tries[j]; }
      return null;
    }
    /* the other colour that can still be bought with this one: nearest to the one now chosen */
    function partner(k, n) {
      var other = k === 'pod' ? proOrder : podOrder, now = k === 'pod' ? S.pro : S.pod, i = other.indexOf(now), j, c;
      for (j = 1; j < other.length; j++) {
        c = other[(i + j) % other.length];
        if (k === 'pod' ? ok(n, c) : ok(c, n)) return c;
      }
      return null;
    }

    function img(v) {
      var fi = v.featured_image || (v.featured_media && v.featured_media.preview_image);
      var s = fi && fi.src ? fi.src : '';
      return s.indexOf('//') === 0 ? 'https:' + s : s;
    }
    function sized(s, w) { return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    var photoToken = 0;
    function setPhoto(v) {
      var el = $('.slide .obj-img', root), s = img(v);
      if (!el || !s || el.dataset.pbSrc === s) return;
      el.dataset.pbSrc = s;
      var token = ++photoToken, t = new Image();
      var srcset = [600, 900, 1200, 1600].map(function (w) { return sized(s, w) + ' ' + w + 'w'; }).join(', ');
      var apply = function () {
        if (token !== photoToken) return;
        el.srcset = srcset; el.src = sized(s, 1200);
        el.setAttribute('data-zoom-src', sized(s, 1800));
        el.alt = 'PurjFam POD in ' + v.options[0] + ' with XKAH Pro in ' + v.options[1] + ', side by side';
      };
      t.sizes = el.sizes || ''; t.srcset = srcset; t.src = sized(s, 1200);
      if (t.decode) t.decode().then(apply, apply); else apply();
    }

    /* Pair band: the two side photos and the one line under them */
    var pairEl = $('[data-pb-pair]', root.ownerDocument), pairData = null;
    try { pairData = JSON.parse($('[data-pb-pair-data]', root.ownerDocument).textContent); } catch (e2) {}
    function setBand(v) {
      if (!pairEl || !pairData) return;
      var pd = pairData.pod[S.pod], xd = pairData.pro[S.pro];
      [['[data-pb-side]', pd && pd.src, 'PurjFam POD ' + (pd ? pd.line : '') + ' in ' + S.pod + ', side view'], ['[data-pb-pro]', xd && xd.src, 'XKAH Pro in ' + S.pro]].forEach(function (a) {
        var im = $(a[0], pairEl); if (!im || !a[1] || im.dataset.pbSrc === a[1]) return;
        im.dataset.pbSrc = a[1];
        var t = new Image(), done = function () { if (im.dataset.pbSrc === a[1]) { im.removeAttribute('srcset'); im.src = a[1]; im.alt = a[2]; } };
        t.src = a[1]; if (t.decode) t.decode().then(done, done); else done();
      });
      var w = $('[data-pb-led-w]', pairEl), led = $('[data-pb-led]', pairEl);
      var sum = pd && xd ? pd.price + xd.price : 0, show = !!(pd && xd && v.compare_at_price && sum === v.compare_at_price && wasOk[v.id] && v.compare_at_price > v.price);
      if (w) w.hidden = !show;
      if (led) {
        led.textContent = '';
        if (show) {
          var mk = function (label, amt, tail) {
            var sp = document.createElement('span'); sp.className = 'np'; sp.appendChild(document.createTextNode(label));
            var b = document.createElement('b'); b.textContent = amt; sp.appendChild(b);
            if (tail) sp.appendChild(document.createTextNode(tail));
            return sp;
          };
          led.appendChild(mk('POD ' + pd.line + ' ', money(pd.price)));
          led.appendChild(document.createTextNode(' + '));
          led.appendChild(mk('XKAH Pro ', money(xd.price)));
          led.appendChild(document.createTextNode(' = '));
          led.appendChild(mk('', money(v.compare_at_price), ' bought separately.'));
        }
      }
    }

    function finish(p) { return lineOf(p) === 'vivid' ? 'One colour, handle to match' : (p === 'Black' ? 'All black' : 'Black rear and handle'); }
    function linePrice(line) {
      if (lineOf(S.pod) === line) return '';
      var ps = vs.filter(function (v) { return v.available && lineOf(v.options[0]) === line && v.options[1] === S.pro; }).map(function (v) { return v.price; });
      if (!ps.length) return '';
      var mn = Math.min.apply(null, ps), mx = Math.max.apply(null, ps), cur = (match(S.pod, S.pro) || {}).price;
      if (mn !== mx) return 'from ' + money(mn);
      return mn !== cur ? money(mn) : '';
    }

    function paint() {
      var v = match(S.pod, S.pro);
      $$('[data-pb-si]', root).forEach(function (si) {
        var k = si.dataset.k, n = si.dataset.n, on = (k === 'pod' ? S.pod : S.pro) === n, so = k === 'pod' ? !podOk(n) : !proOk(n);
        si.classList.toggle('is-on', on); si.classList.toggle('is-so', so);
        var c = $('[data-pb-chip]', si);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        if (so) c.setAttribute('aria-disabled', 'true'); else c.removeAttribute('aria-disabled');
        var g = si.closest('[data-pb-group]'); if (g && !g.contains(document.activeElement)) c.tabIndex = on ? 0 : -1;
        var hid = $('.visually-hidden', c); if (hid) hid.textContent = n + (k === 'pod' ? ', ' + (lineOf(n) === 'noir' ? 'Noir' : 'Vivid') : '') + (so ? ', sold out' : '');
      });
      $$('[data-pb-sel="pod"]', document).forEach(function (e) { e.textContent = S.pod; });
      $$('[data-pb-sel="pro"]', document).forEach(function (e) { e.textContent = S.pro; });
      var fin = $('[data-pb-fin]', root); if (fin) fin.textContent = finish(S.pod);
      $$('[data-pb-lp]', root).forEach(function (e) { e.textContent = linePrice(e.dataset.pbLp); });
      var sv = $('[data-pb-save]', root);
      if (sv) { var s = v && v.available && wasOk[v.id] && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0; sv.textContent = s >= 100 ? 'Save ' + money(s) : ''; }
      ['pod', 'pro'].forEach(function (k) {
        var box = $('[data-pb-msg="' + k + '"]', root); if (!box) return;
        var m = S.msg && S.msg.k === k ? S.msg : null;
        box.classList.toggle('is-on', !!m); box.textContent = '';
        if (m) {
          var sp = document.createElement('span'); sp.textContent = m.t; box.appendChild(sp);
          if (m.to) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-pb-try', k); b.setAttribute('data-to', m.to); b.textContent = 'Try ' + m.to; box.appendChild(b); }
        }
      });
      if (v) { setPhoto(v); setBand(v); }
    }

    function setUrl(id) {
      try {
        var u = new URLSearchParams(); keep.forEach(function (kv) { u.append(kv[0], kv[1]); }); u.set('variant', id);
        history.replaceState({}, '', location.pathname + '?' + u.toString());
      } catch (e3) {}
    }
    function drive(v) {
      if (!sel) return;
      if (String(sel.value) !== String(v.id)) { sel.value = String(v.id); sel.dispatchEvent(new Event('change', { bubbles: true })); }
      setUrl(v.id); /* pdpv9 rewrites ?variant= on its own; this keeps any other query (a preview, a campaign tag) */
    }
    function pick(k, n, msg) {
      if (k === 'pod') S.pod = n; else S.pro = n;
      var v = match(S.pod, S.pro);
      S.msg = msg || null;
      if (v && !v.available) {
        var to = partner(k, n);
        S.msg = { k: k, t: S.pod + ' with ' + S.pro + ' is sold out.', to: to };
        S.msgTarget = to;
      }
      paint();
      if (v) drive(v);
    }
    function tap(k, n) {
      var so = k === 'pod' ? !podOk(n) : !proOk(n);
      if (so) { var to = near(k, n); S.msg = { k: k, t: n + ' is sold out.', to: to }; paint(); return; }
      pick(k, n, null);
    }
    function tryTo(k, to) {
      /* an explicit tap on Try: set that colour, and if its pair with the other choice cannot be bought say which other colour is shown */
      var before = k === 'pod' ? S.pod : S.pro;
      if (k === 'pod') S.pod = to; else S.pro = to;
      var v = match(S.pod, S.pro);
      if (v && !v.available) {
        var o = k === 'pod' ? 'pro' : 'pod', alt = partner(k, to);
        if (alt) { if (o === 'pro') S.pro = alt; else S.pod = alt; v = match(S.pod, S.pro); S.msg = { k: k, t: to + ' with ' + alt + '.', to: null }; }
      } else { S.msg = null; }
      if (before === to) S.msg = null;
      paint(); if (v) drive(v);
    }

    root.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-pb-chip]');
      if (c) { var si = c.closest('[data-pb-si]'); tap(si.dataset.k, si.dataset.n); return; }
      var t = e.target.closest && e.target.closest('[data-pb-try]');
      if (t) { tryTo(t.dataset.pbTry, t.dataset.to); }
    });
    root.addEventListener('keydown', function (e) {
      var c = e.target.closest && e.target.closest('[data-pb-chip]'); if (!c) return;
      var g = c.closest('[data-pb-group]'), kids = $$('[data-pb-chip]', g), i = kids.indexOf(c), nx = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') nx = kids[(i + 1) % kids.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') nx = kids[(i - 1 + kids.length) % kids.length];
      if (!nx) return;
      e.preventDefault();
      kids.forEach(function (x) { x.tabIndex = -1; }); nx.tabIndex = 0; nx.focus();
      var nsi = nx.closest('[data-pb-si]');
      if (nx.getAttribute('aria-disabled') !== 'true') pick(nsi.dataset.k, nsi.dataset.n, null);
    });
    root.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var c = e.target.closest && e.target.closest('[data-pb-chip]'); if (!c) return;
      var si = c.closest('[data-pb-si]'), p = si.dataset.k === 'pod' ? si.dataset.n : S.pod, x = si.dataset.k === 'pro' ? si.dataset.n : S.pro, v = match(p, x);
      if (v) { var s = img(v); if (s) { var t = new Image(); t.sizes = ''; t.srcset = sized(s, 1200) + ' 1200w'; t.src = sized(s, 1200); } }
    });

    /* a link that named a sold-out pair was reseeded to the nearest one that can be bought (server side); put the address bar on what is shown */
    if (note) setUrl(start.id);
    paint();
  }

  function boot() { $$('[data-pdpv9].pdpv9--stage').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
